import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { I18nService } from '@app/@core/services';
import { getISOWeek } from 'date-fns';

@Component({
  selector: 'app-date-localed',
  template: `{{ opts.date | date: opts.format :'': i18nService.language }} <span *ngIf="opts.dateMode === 2">{{ 'COMMON_DATE_EVENTS.WEEK_LONG' | transloco: { value: week } }}</span>`
})
export class DateLocaledComponent implements OnInit, OnChanges {
  @Input() opts: { date: Date, format: string, dateMode: any };
  week: number;

  constructor(readonly i18nService: I18nService) { }
  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.opts.dateMode === 2 && changes.opts.currentValue) {
      this.opts.format = 'yyyy';
      this.week = getISOWeek(new Date(changes.opts.currentValue.date));
    }
  }
}
